module.exports = __webpack_public_path__ + "static/media/sauna-image.006edc33.jpg";